import React from "react";
import "../CSS/ApostilleMumbai.css";
import { Link } from "react-router-dom";

const ApostilleMumbai = () => {
  return (
    <section className="mumbai-apostille-page">
      <div className="mumbai-apostille-banner">
        <h1 className="mumbai-apostille-banner-title">
          Apostille Service in Mumbai
        </h1>

        <p className="mumbai-apostille-breadcrumb">
          <Link to="/">Home</Link> &gt;
          <span> Apostille Service in Mumbai</span>
        </p>
      </div>

      <div className="mumbai-apostille-layout">
        <aside className="mumbai-apostille-sidebar">
          <div className="mumbai-apostille-sidebox">
            <h3 className="mumbai-apostille-sidebox-title">
              APOSTILLE SERVICES
            </h3>
            <ul className="mumbai-apostille-side-list">
              <li className="mumbai-apostille-side-item">
                Educational Document Apostille
              </li>
              <li className="mumbai-apostille-side-item">
                Personal Document Apostille
              </li>
              <li className="mumbai-apostille-side-item">
                Commercial Document Apostille
              </li>
            </ul>
          </div>

          <div className="mumbai-apostille-sidebox">
            <h3 className="mumbai-apostille-sidebox-title">QUICK LINKS</h3>
            <ul className="mumbai-apostille-side-list">
              <li className="mumbai-apostille-side-item">
                Apostille Services in Mumbai
              </li>
              <li className="mumbai-apostille-side-item">
                Document Apostille Process
              </li>
              <li className="mumbai-apostille-side-item">
                MEA Approved Universities
              </li>
              <li className="mumbai-apostille-side-item">
                Apostille Country List
              </li>
              <li className="mumbai-apostille-side-item">
                Non Apostille Country List
              </li>
              <li className="mumbai-apostille-side-item">
                Apostille Accepted Embassy List
              </li>
              <li className="mumbai-apostille-side-item">
                Apostille Member Countries
              </li>
              <li className="mumbai-apostille-side-item">
                Apostille Centers – Mumbai
              </li>
            </ul>
          </div>
        </aside>

        <main className="mumbai-apostille-content">
          <h2 className="mumbai-apostille-main-title">
            Apostille Services in Mumbai
          </h2>

          <p className="mumbai-apostille-text">
            Apostille services in Mumbai are required when Indian documents need
            to be legally used in foreign countries that are members of the
            Hague Apostille Convention. An apostille is an official
            authentication issued by the
            <strong> Ministry of External Affairs (MEA), Government of India</strong>
            that confirms the authenticity of documents for international use.
          </p>

          <p className="mumbai-apostille-text">
            Individuals, students, and businesses in Mumbai commonly require
            document apostille services for purposes such as higher education
            abroad, overseas employment, immigration, family visa applications,
            and international business expansion.
          </p>

          <p className="mumbai-apostille-text">
            Our professional apostille consultants in Mumbai provide reliable,
            secure and fast document apostille services for educational,
            personal, and commercial documents. We assist clients with the
            complete apostille process from document verification to final MEA
            apostille certification.
          </p>

          <p className="mumbai-apostille-text">
            <strong>NOTE:</strong> Some countries may require embassy
            attestation in addition to apostille certification. Our experts in
            Mumbai can guide you through the correct document legalization
            process depending on the destination country.
          </p>

          <p className="mumbai-apostille-highlight-link">
            List of Countries That Require Apostille
          </p>

          <h3 className="mumbai-apostille-section-title">
            Professional Apostille Services for Documents in Mumbai
          </h3>

          <p className="mumbai-apostille-text">
            We provide trusted apostille services in Mumbai for individuals,
            students, professionals and corporate clients. Our team handles the
            entire apostille process through authorized procedures approved by
            the Ministry of External Affairs (MEA).
          </p>

          <p className="mumbai-apostille-text">
            Our services include document verification, notarization, state
            authentication where required, and final apostille stamping from the
            Ministry of External Affairs.
          </p>

          <p className="mumbai-apostille-text">
            For the convenience of our clients, we also offer
            <strong> doorstep document pickup and delivery services across Mumbai</strong>,
            making the apostille process simple, fast and hassle-free.
          </p>

          <p className="mumbai-apostille-text">
            For more information call us at +91-8589 008 001 / +91-8588 808 183
            or email us at care@vizatt.in.
          </p>

          <p className="mumbai-apostille-text">
            Call +91 8750-388-388 for free document pick-up and drop service in
            Mumbai.
          </p>

          <p className="mumbai-apostille-text">
            For details about regional apostille centers and authorities
            <span className="mumbai-apostille-highlight-link"> Click Here</span>
          </p>

          <h3 className="mumbai-apostille-section-title">
            MEA Apostille Process in Mumbai
          </h3>

          <p className="mumbai-apostille-text">
            The apostille process in Mumbai involves several verification stages
            before the final apostille certificate is issued by the Ministry of
            External Affairs (MEA), Government of India.
          </p>

          <p className="mumbai-apostille-text">
            Documents are first verified by the relevant authorities such as a
            notary public or state authentication department depending on the
            type of document.
          </p>

          <p className="mumbai-apostille-text">
            After successful verification, the documents are submitted to the
            Ministry of External Affairs for apostille certification, allowing
            them to be legally recognized in foreign countries.
          </p>

          <p className="mumbai-apostille-text">
            Our apostille experts in Mumbai ensure quick processing, secure
            handling of documents and reliable document legalization services
            for all types of apostille requirements.
          </p>

          <h2 className="mumbai-apostille-main-title">
            Documents Eligible for Apostille in Mumbai
          </h2>

          <p className="mumbai-apostille-doc-intro">
            Below is a list of commonly apostilled documents in Mumbai. If your
            required document is not listed here, please contact our apostille
            consultants for assistance at +91-8589 008 001 / +91-8588 808 183.
          </p>

          <h3 className="mumbai-apostille-section-title">
            Degree Certificate Apostille
          </h3>
          <div className="mumbai-apostille-table-wrap">
            <table className="mumbai-apostille-table">
              <tbody>
                <tr>
                  <td className="mumbai-apostille-table-title">
                    Document Checklist
                  </td>
                  <td>
                    1. Original Degree Certificate <br />
                    2. Passport copy
                  </td>
                </tr>
                <tr>
                  <td className="mumbai-apostille-table-title">
                    Processing Time
                  </td>
                  <td>3-5 Working days</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="mumbai-apostille-doc-desc">
            Degree certificate apostille in Mumbai is commonly required for
            higher education and employment abroad. Certificates issued by
            recognized Indian universities are eligible for apostille
            authentication.
          </p>

          <h3 className="mumbai-apostille-section-title">
            Birth Certificate Apostille
          </h3>
          <div className="mumbai-apostille-table-wrap">
            <table className="mumbai-apostille-table">
              <tbody>
                <tr>
                  <td className="mumbai-apostille-table-title">
                    Document Checklist
                  </td>
                  <td>
                    1. Original Birth Certificate <br />
                    2. Passport copy
                  </td>
                </tr>
                <tr>
                  <td className="mumbai-apostille-table-title">
                    Processing Time
                  </td>
                  <td>2-3 Working days</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="mumbai-apostille-doc-desc">
            Birth certificate apostille in Mumbai is required for immigration,
            family visa, education and residency purposes. Certificates issued
            by municipal corporations or government authorities can be
            apostilled.
          </p>

          <h3 className="mumbai-apostille-section-title">
            Marriage Certificate Apostille
          </h3>
          <div className="mumbai-apostille-table-wrap">
            <table className="mumbai-apostille-table">
              <tbody>
                <tr>
                  <td className="mumbai-apostille-table-title">
                    Document Checklist
                  </td>
                  <td>
                    1. Original Marriage Certificate <br />
                    2. Passport copy
                  </td>
                </tr>
                <tr>
                  <td className="mumbai-apostille-table-title">
                    Processing Time
                  </td>
                  <td>2-3 Working days</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="mumbai-apostille-doc-desc">
            Marriage certificate apostille in Mumbai is commonly required for
            spouse visa, family visa and immigration applications. Government
            issued marriage certificates are eligible for apostille
            authentication.
          </p>

          <h3 className="mumbai-apostille-section-title">
            Power Of Attorney Apostille
          </h3>
          <div className="mumbai-apostille-table-wrap">
            <table className="mumbai-apostille-table">
              <tbody>
                <tr>
                  <td className="mumbai-apostille-table-title">
                    Document Checklist
                  </td>
                  <td>
                    1. Original Power of Attorney <br />
                    2. Passport copy
                  </td>
                </tr>
                <tr>
                  <td className="mumbai-apostille-table-title">
                    Processing Time
                  </td>
                  <td>2-3 Working days</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 className="mumbai-apostille-section-title">
            Affidavit Apostille
          </h3>
          <div className="mumbai-apostille-table-wrap">
            <table className="mumbai-apostille-table">
              <tbody>
                <tr>
                  <td className="mumbai-apostille-table-title">
                    Document Checklist
                  </td>
                  <td>
                    1. Original Affidavit <br />
                    2. Passport copy
                  </td>
                </tr>
                <tr>
                  <td className="mumbai-apostille-table-title">
                    Processing Time
                  </td>
                  <td>2-3 Working days</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="mumbai-apostille-doc-desc">
            Affidavit apostille in Mumbai is commonly required for legal
            declarations, visa applications and international documentation.
            Affidavits prepared by a notary public or advocate can be
            apostilled for international use.
          </p>
        </main>
      </div>
    </section>
  );
};

export default ApostilleMumbai;